import React, { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { toast } from "sonner";
import { api, formatApiError } from "@/lib/api";

export default function BookAppointment() {
  const [params] = useSearchParams();
  const [doctors, setDoctors] = useState([]);
  const [specialties, setSpecialties] = useState([]);
  const [form, setForm] = useState({
    name: "", age: "", gender: "", mobile: "", email: "",
    doctor_id: params.get("doctor") || "",
    department: params.get("department") || "",
    preferred_date: "", preferred_time: "",
    notes: params.get("package") ? `Package booking: ${params.get("package")}` : "",
  });
  const [submitting, setSubmitting] = useState(false);

  useEffect(() => {
    Promise.all([api.get("/doctors"), api.get("/specialties")]).then(([d, s]) => {
      setDoctors(d.data); setSpecialties(s.data);
    });
  }, []);

  const submit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    try {
      const payload = { ...form, age: Number(form.age) };
      await api.post("/appointments", payload);
      toast.success("Appointment requested! We'll confirm via WhatsApp shortly.");
      setForm({ name: "", age: "", gender: "", mobile: "", email: "", doctor_id: "", department: "", preferred_date: "", preferred_time: "", notes: "" });
    } catch (err) { toast.error(formatApiError(err.response?.data?.detail)); }
    finally { setSubmitting(false); }
  };

  return (
    <div data-testid="book-page">
      <section className="hero-bg py-12">
        <div className="container-x">
          <span className="font-cursive text-2xl text-brand-purple">Book Appointment</span>
          <h1 className="text-4xl sm:text-5xl font-bold">Schedule your visit</h1>
        </div>
      </section>

      <section className="container-x py-10">
        <form onSubmit={submit} className="card-clean p-6 md:p-10 max-w-3xl mx-auto grid sm:grid-cols-2 gap-4" data-testid="appointment-form">
          <input required value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} placeholder="Patient name" data-testid="appt-name" />
          <input required type="number" min="1" max="120" value={form.age} onChange={(e) => setForm({ ...form, age: e.target.value })} placeholder="Age" data-testid="appt-age" />
          <select required value={form.gender} onChange={(e) => setForm({ ...form, gender: e.target.value })} data-testid="appt-gender">
            <option value="">Select gender</option><option>Male</option><option>Female</option><option>Other</option>
          </select>
          <input required value={form.mobile} onChange={(e) => setForm({ ...form, mobile: e.target.value })} placeholder="Mobile number" data-testid="appt-mobile" />
          <input type="email" className="sm:col-span-2" value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} placeholder="Email (optional)" data-testid="appt-email" />
          <select required value={form.department} onChange={(e) => setForm({ ...form, department: e.target.value })} data-testid="appt-department">
            <option value="">Select department</option>
            {specialties.map((s) => <option key={s.id} value={s.name}>{s.name}</option>)}
          </select>
          <select value={form.doctor_id} onChange={(e) => setForm({ ...form, doctor_id: e.target.value })} data-testid="appt-doctor">
            <option value="">Any available doctor</option>
            {doctors.filter((d) => !form.department || d.specialty === form.department).map((d) => <option key={d.id} value={d.id}>{d.name}</option>)}
          </select>
          <input required type="date" value={form.preferred_date} onChange={(e) => setForm({ ...form, preferred_date: e.target.value })} data-testid="appt-date" min={new Date().toISOString().split("T")[0]} />
          <input required type="time" value={form.preferred_time} onChange={(e) => setForm({ ...form, preferred_time: e.target.value })} data-testid="appt-time" />
          <textarea rows="3" className="sm:col-span-2" value={form.notes} onChange={(e) => setForm({ ...form, notes: e.target.value })} placeholder="Notes / reason for visit (optional)" data-testid="appt-notes" />
          <button disabled={submitting} className="btn-primary sm:col-span-2 justify-center" data-testid="appt-submit">{submitting ? "Submitting…" : "Request Appointment"}</button>
        </form>
      </section>
    </div>
  );
}
